module.exports = __webpack_public_path__ + "static/img/whatsapp.5a2d813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/whatsapp.png
// module id = Mf/W
// module chunks = 36